import React from "react";
import PredictionPage from "../../components/PredictionPage";

function COPPER() {
  return (
    <PredictionPage
      title="COPPER"
      content="This is the COPPER AI Trading Predictions page."
      canonical="/metals/copper-ai-trading-predictions"
      categoryKey="nav.metals"
      categoryPath="/metals"
      symbol="COPPER"
    />
  );
}

export default COPPER;
